// extracted by mini-css-extract-plugin
export default {"headerClass":"SliderSection_headerClass__lsUXY","sliderDiv":"SliderSection_sliderDiv__AUD+K"};